import { FormControl, FormGroup } from '@angular/forms';
import {AngularFirestore} from '@angular/fire/firestore';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CardService {
  constructor(private firestore: AngularFirestore ) {}

  form = new FormGroup({
    title: new FormControl(''),
    title2: new FormControl(''),
    scheda: new FormControl(''),
    description: new FormControl(''),
    description2: new FormControl(''),
    description3: new FormControl(''),
    description4: new FormControl(''),
    price: new FormControl(''),
    id: new FormControl(''),
    code: new FormControl(''),
    mail: new FormControl(''),
    percent: new FormControl(''),
    disable: new FormControl(''),
  });


  getCoffeeOrders() {
    return this.firestore.collection('card', ref => {
      return ref.orderBy('id', 'asc');
    }).snapshotChanges();
  }
  getCoffeeOrdersCoupon() {
    return this.firestore.collection('card_coupon', ref => {
      return ref.orderBy('id', 'asc');
    }).snapshotChanges();
  }
  getCoupon() {
    return this.firestore.collection('coupon', ref => {
      return ref.orderBy('code', 'asc');
    }).snapshotChanges();
  }


}
